import { template } from "@ember/template-compiler";
export default template(`
	<footer class="info">
		<p>Double-click to edit a todo</p>
		<p>
			Created by
			<a href="https://github.com/cibernox">Miguel Camba</a>,
			<a href="https://github.com/addyosmani">Addy Osmani</a>,
			<a href="https://github.com/NullVoxPopuli">NullVoxPopuli</a>
		</p>

		<p>Part of <a href="https://todomvc.com">TodoMVC</a></p>
	</footer>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
